module.exports = __webpack_public_path__ + "assets/img/img335.3c4ed162.png";